const nodeURL = process.env.REACT_APP_STRAPI_URL
const headers = () => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
})

// // ********** CREATE CHANGE LOG  ********** //
export const createChangeLog = async (details) => {
    const opts = {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify(details),
    }

    const response = await fetch(`${nodeURL}/activitylogs`, opts);
    const data = response.json();

    return data;
}

// ********** GET ALL CHANGE LOGS FOR WORK ORDER ********** //
export const fetchChangeLogsByWorkOrder = async (woId) => {
    const opts = {
        method: 'GET',
        headers: headers(),
    }

    const response = await fetch(`${nodeURL}/activitylogs?workorder_eq=${woId}&_limit=100&_sort=createdAt:DESC`, opts);
    const data = response.json();

    return data;
}

// ********** GET ALL WORK ORDERS  ********** //
export const fetchChangeLogsCountByWorkOrder = async (woId) => {
    const opts = {
        method: 'GET',
        headers: headers(),
    }

    const response = await fetch(`${nodeURL}/activitylogs/count?workorder_eq=${woId}`, opts);
    const data = response.json();

    return data;
}


export const fetchMoreChangesLogByWorkOrder = async (woId, offset) => {
    const opts = {
        method: 'GET',
        headers: headers(),
    }

    const response = await fetch(`${nodeURL}/activitylogs?workorder_eq=${woId}&_limit=100&_start=${offset}&_sort=createdAt:DESC`, opts);
    const data = response.json();

    return data;
}